import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RehabilitationProgramDTO } from './rehabilitation.dto';

@Injectable({
  providedIn: 'root',
})
export class RehabilitationApi {
  private readonly apiUrl: string = environment.apiUrl;

  constructor(private readonly http: HttpClient) {}

  getByIds(ids: number[]): Observable<RehabilitationProgramDTO[]> {
    const idsParam = ids.join(',');
    return this.http.get<RehabilitationProgramDTO[]>(
      this.apiUrl + `/clinic/rehabilitation-program/by-ids?ids=[${idsParam}]`,
    );
  }

  getById(id: number): Observable<RehabilitationProgramDTO> {
    return this.http.get<RehabilitationProgramDTO>(this.apiUrl + `/clinic/rehabilitation-program/${id}`);
  }
}
